export enum META_TAGS {
  DESCRIPTION = 'description',
  ROBOTS = 'robots',
}
